const styleelem = document.createElement("style");
styleelem.innerHTML = `
  .country-error { display: none; color: #FF0000; margin-top: 10px; font-family: Helvetica; font-size: 12px; letter-spacing: 0.05em; font-weight: 600; }
  button._formSubmitButton_1nihh_77:disabled { opacity: 0.5 !important; }
`;

const countryError = document.createElement("output");
countryError.setAttribute("role", "alert");
countryError.setAttribute("aria-live", "polite");
countryError.className = "country-error";
countryError.innerHTML = "Sorry, we currently only ship within the United States.";

document.addEventListener("DOMContentLoaded", () => {
  const retryInterval = setInterval(() => {
    const appEmbed = document.querySelector("#app-embed");
    if (appEmbed && appEmbed.shadowRoot) {
      clearInterval(retryInterval);

      appEmbed.shadowRoot.appendChild(styleelem);

      const countryButton = appEmbed.shadowRoot.querySelector('button[aria-controls="shipping_address_country-selector-dropdown"]');
      const submitButton = appEmbed.shadowRoot.querySelector("button._formSubmitButton_1nihh_77");

      if (countryButton && submitButton) {
        const parentContainer = countryButton.parentElement;
        if (parentContainer) {
          parentContainer.appendChild(countryError);
        }

        countryButton.addEventListener("click", () => {
          setTimeout(() => {
            const optionList = appEmbed.shadowRoot.querySelectorAll("div[role='option']");

            optionList.forEach(option => {
              // Prevent attaching multiple listeners
              if (!option.hasAttribute("data-listener-added")) {
                option.setAttribute("data-listener-added", "true");

                option.addEventListener("click", () => {
                  setTimeout(() => {
                    const selectedText = countryButton.querySelector("span._selectToggleText_1yit2_25")?.textContent.trim();
                    const countryErrorElement = appEmbed.shadowRoot.querySelector(".country-error");

                    if (selectedText && selectedText !== "United States") {
                      countryErrorElement.style.display = "block";
                      submitButton.disabled = true;
                    } else {
                      countryErrorElement.style.display = "none";
                      submitButton.disabled = false;
                    }
                  }, 50); // Delay for text update
                });
              }
            });
          }, 50); // Delay to let dropdown options render
        });
      }
    }
  }, 500);
});